/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.personnel.controllers', [])

.controller('ResourcesPersonnelController', ['$scope', function($scope) {

    $scope.resourcesPersonnel = "Your spankin new application.resources.personnel.default view!";

}]);